import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab, Paper } from '@mui/material';
import { DocumentationViewer } from '../components/DocumentationViewer';
import Documentation from './Documentation';
import { Description as DescriptionIcon, Folder as FolderIcon } from '@mui/icons-material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`combined-docs-tabpanel-${index}`}
      aria-labelledby={`combined-docs-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `combined-docs-tab-${index}`,
    'aria-controls': `combined-docs-tabpanel-${index}`,
  };
}

export const DocumentationCombined: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ height: 'calc(100vh - 64px)', display: 'flex', flexDirection: 'column' }}>
      {/* Header */}
      <Paper elevation={0} sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Typography variant="h4" sx={{ p: 3, pb: 2, color: '#003366', fontWeight: 700 }}>
          Documentation Center
        </Typography>
        
        {/* Tabs */}
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange} 
          aria-label="documentation sections"
          sx={{
            px: 3,
            '& .MuiTab-root': {
              color: '#003366',
              fontWeight: 600,
              '&.Mui-selected': {
                color: '#003366',
              },
              '&:focus': {
                outline: '3px solid #003366',
                outlineOffset: 2
              }
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#003366',
              height: 3
            }
          }}
        >
          <Tab 
            label="Documentation Files" 
            icon={<FolderIcon />} 
            iconPosition="start" 
            {...a11yProps(0)}
            aria-label="Browse documentation files organized by category"
          />
          <Tab 
            label="Documentation Hub" 
            icon={<DescriptionIcon />} 
            iconPosition="start" 
            {...a11yProps(1)}
            aria-label="View documentation hub with features and guides"
          />
          <Tab 
            label="Business Value Justification" 
            icon={<DescriptionIcon />} 
            iconPosition="start" 
            {...a11yProps(2)}
            aria-label="View E-Unify Business Value Justification"
          />
        </Tabs>
      </Paper>

      {/* Tab Panels */}
      <Box sx={{ flexGrow: 1, overflow: 'auto' }}>
        {/* Tab 1: Documentation Files (New - File Browser) */}
        <TabPanel value={tabValue} index={0}>
          <DocumentationViewer />
        </TabPanel>

        {/* Tab 2: Documentation Hub (Old - Features & Guides) */}
        <TabPanel value={tabValue} index={1}>
          <Documentation />
        </TabPanel>

        {/* Tab 3: Business Value Justification (Public HTML embed) */}
        <TabPanel value={tabValue} index={2}>
          <Box sx={{ height: 'calc(100vh - 220px)' }}>
            <iframe
              title="E-Unify Business Value Justification"
              src="/docs/Business-Value-Justification.html"
              sandbox="allow-same-origin allow-scripts allow-popups allow-popups-to-escape-sandbox allow-modals"
              style={{ border: 0, width: '100%', height: '100%' }}
            />
          </Box>
        </TabPanel>
      </Box>
    </Box>
  );
};

export default DocumentationCombined;
